import React from 'react'

function LoadingMessage() {
    return(
        <div className="single-message--loading">
            <div id="dot-1" className="single-message--loading__dots"></div>
            <div id="dot-2" className="single-message--loading__dots"></div>
            <div id="dot-3" className="single-message--loading__dots"></div>
        </div>
    );
}

export default LoadingMessage;